
export default Object.freeze({
    PriceModels: {
        PerMonth: { value: 1, text: 'Per month' },
        PerUnit: { value: 2, text: 'Per unit' }
    },
});